import * as React from 'react';

export default class Personal extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
        <svg className={this.props.className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" >
            <g fill="none" fillRule="evenodd">
            <g>
                <g>
                    <g>
                        <g transform="translate(-78 -469) translate(68 221) translate(0 240) translate(10 8)">
                            <path fill="#333" d="M12.066 6C13.249 7.018 14 8.53 14 10.222c0 3.061-2.462 2.772-5.5 2.772S3 13.283 3 10.22c0-1.69.75-3.204 1.934-4.22.695 1.22 2.031 2.045 3.566 2.045 1.5 0 2.81-.788 3.518-1.962z"/>
                            <circle cx="8.5" cy="4.5" r="2.5" fill="#333"/>
                            <path stroke="#FFF" d="M6 14L8 11"/>
                        </g>
                    </g>
                </g>
            </g>
            </g>
        </svg>
    )
  }
}
